import { ChevronDown, ChevronUp } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { type PaymentRead, type PaymentStatus } from "@/api-v3";
import {
  PaymentListItemComponent,
  getPaymentDisplayAmount,
  getPaymentTitle,
  raisedByStudyTeam,
} from "@/features/payments";
import { formatISODate } from "@/lib/date-formatter";

import { VisitSubmittedItems } from "./visit-submitted-items";

interface VisitPaymentsListProps {
  payments: PaymentRead[];
}

export const VisitPaymentsList = ({ payments }: VisitPaymentsListProps) => {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(false);

  return (
    <div className="mt-3 w-full" data-test-id="visit-payments-list">
      <VisitSubmittedItems payments={payments} />
      <button
        type="button"
        onClick={() => setExpanded((prev) => !prev)}
        aria-expanded={expanded}
        className="mt-1 inline-flex items-center gap-x-1 text-sm font-medium text-primary hover:underline"
        data-test-id="visit-payments-toggle"
      >
        {expanded ? t("hidePayments") : t("viewPayments")}
        {expanded ? (
          <ChevronUp className="size-4" />
        ) : (
          <ChevronDown className="size-4" />
        )}
      </button>
      {expanded && (
        <ul className="mt-2 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 items-start">
          {payments.map((payment) => (
            <li key={payment.id}>
              <PaymentListItemComponent
                id={payment.id}
                title={getPaymentTitle(payment.type, t)}
                subtitle={formatISODate(payment.created_at, {
                  format: "short-date",
                })}
                amount={getPaymentDisplayAmount(payment)}
                currency={payment.currency}
                status={payment.status as PaymentStatus}
                type={payment.type}
                payoutStatus={payment.payout_status}
                raisedByStudyTeam={raisedByStudyTeam(payment)}
              />
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
